<template>
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="px-4 w-full">
        <BigTitle title="Settings" class="mb-11 pt-40"/>
        <BillingPlans />
      </div>
    </div>
  </div>
</template>

<script>
  import BillingPlans from '@/components/settings/BillingPlans'
  import BigTitle from '@/components/BigTitle'

  export default {
    components: {
      BillingPlans,
      BigTitle
    },
  }
</script>

<style lang="scss" scoped>

</style>